import { Action } from 'redux'

import { ENABLE_DELETE_PASSENGERS } from '../../actions/deletePassengers/enableDeletePassengers'
import { DISABLE_DELETE_PASSENGERS } from '../../actions/deletePassengers/disableDeletePassengers'

export interface DeletePassengersState {
  isDeletePassengersEnabled: boolean
  isDeleteAllPassengersChecked: boolean
}

export const initialState: DeletePassengersState = {
  isDeletePassengersEnabled: false,
  isDeleteAllPassengersChecked: false,
}

export default (
  state = initialState,
  action: Action = {
    type: '',
  }
) => {
  switch (action.type) {
    case ENABLE_DELETE_PASSENGERS:
      return {
        ...state,
        isDeletePassengersEnabled: true,
      }

    case '@@router/LOCATION_CHANGE':
    case DISABLE_DELETE_PASSENGERS:
      return {
        ...state,
        isDeletePassengersEnabled: false,
      }

    default:
      return state
  }
}
